import request from "@/utils/httpRequest.js"

 export function preview(params) {
  return request({
    url: 'form/base/preview',
    method: 'get',
    params
  })
}
